module.exports = {"key":"hello german","submit":"Enviar Feedback","hide":"Esconder Isso","skip":"Pular para a próxima questão","placeholder":"Por favor, descreva como você se sente sobre isso..."}


//////////////////
// WEBPACK FOOTER
// ./src/translations/pt.json
// module id = 448
// module chunks = 0